module.exports = __webpack_public_path__ + "img/background.789b9a54.png";